const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const CACHE_KEY = 'surf_maintenance_enabled';
const DEFAULT_TIMEOUT_MS = 10000;

export function maintenanceStatusUrl(): string {
  return `${API_BASE_URL}/site/maintenance`;
}

/** Último estado conocido (p. ej. tras activar mantenimiento en /admin). */
export function readMaintenanceCache(): boolean | null {
  try {
    const value = localStorage.getItem(CACHE_KEY);
    if (value === 'true') return true;
    if (value === 'false') return false;
  } catch {
    // localStorage no disponible
  }
  return null;
}

export function writeMaintenanceCache(enabled: boolean): void {
  try {
    localStorage.setItem(CACHE_KEY, enabled ? 'true' : 'false');
  } catch {
    // no-op
  }
}

/** Estado desde el backend. Lanza si la respuesta no es OK o hay timeout. */
export async function fetchMaintenanceEnabled(timeoutMs = DEFAULT_TIMEOUT_MS): Promise<boolean> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(maintenanceStatusUrl(), {
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!res.ok) throw new Error(`maintenance ${res.status}`);
    const data = (await res.json()) as { enabled?: boolean };
    const enabled = Boolean(data.enabled);
    writeMaintenanceCache(enabled);
    return enabled;
  } finally {
    window.clearTimeout(timer);
  }
}
